import * as Yup from 'yup'
export function ValidateEmails(values) {
    return Yup.object().shape({
        email: Yup.string().required('This field is required'),
    });
}

export function ValidateAddEmails(values) {
    return Yup.object().shape({
        emails: Yup.array(Yup.object({
            email: Yup.string().email('Please enter a valid email').required('This field is required'),
        })).required("This field is required"),
    });
}


